import React, { useState, useEffect } from 'react'
import { Box, Grid, Select, NumberInput, Flex, Group, Button } from '@mantine/core'
import { useSelector, useDispatch } from 'react-redux'
import { updateOrder } from '../../../../../services/orders'
import { useParams } from 'react-router-dom'
import { getOrderDetail } from '../../../../../store/orderDetail'
import { notificationSuccess, notificationError, loadingNotification, completedLoadingNotification } from '../../../../ui/Notifications'
import { calculation } from '../../../../../services/calculation'
import { validation } from '../../../../../plugins/validation'
import { getAllCurrencyList } from '../../../../../services/currency'
import LoadingData from '../../../../ui/LoadingData'

const defaultVal = {
  currency_origin: null,
  currency_order: null,
  conversion: null,
  user_conversion: null,
}

const formValidation = {
  conversion: {
    isError: false,
    message: ''
  },
  user_conversion: {
    isError: false,
    message: ''
  }
}

const FormAdjustCurrency = ({ onCloseForm }) => {
  const { summary } = useSelector(state => state.order_detail)
  const dispatch = useDispatch()
  const params = useParams()
  const orderId = params.order_id
  const [formData, setFormData] = useState(defaultVal)
  const [validationForm, setValidationForm] = useState(formValidation)
  const [loadingForm, setLoadingForm] = useState(false)
  const [loadingCurrencies, setLoadingCurrencies] = useState(true)
  const [currencyList, setCurrencyList] = useState([])

  const submitUpdateCurrency = async (form) => {
    setLoadingForm(true)
    setValidationForm(formValidation)
    const validateForm = {
      conversion: form.conversion,
      user_conversion: form.user_conversion
    }
    const isError = validation(validateForm, setValidationForm)
    if (isError) {
      setLoadingForm(false)
      return
    }
    try {
      const response = await updateOrder(orderId, form)
      if (response.success) {
        notificationSuccess('Update Order Successfully', 'This data has been updated')
        const loadingCalculation = loadingNotification('Waiting Calculation Order', 'Please Wait. . .')
        const responseCalculation = await calculation(orderId)
        if (responseCalculation.success) {
          onCloseForm()
          dispatch(getOrderDetail(orderId))
          completedLoadingNotification(loadingCalculation, 'Calculation Order Successfully', 'This order has been completed in calculation')
        }
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      notificationError('Update Order Error', `${errorMessage ? errorMessage : 'Please recheck your form'}`)
    } finally {
      setLoadingForm(false)
    }
  }

  const handleGetCurrenciesList = async () => {
    setLoadingCurrencies(true)
    const params = {
      groupBy: 'currency_code'
    }
    try {
      const response = await getAllCurrencyList(params)
      const dataCurrencies = response.data
      const remapCurrency = dataCurrencies.map((val) => {
        return val.attributes.currency_code
      })
      setCurrencyList(remapCurrency)
    } catch (error) {
      console.log(error)
    } finally {
      setLoadingCurrencies(false)
    }
  }

  useEffect(() => {
    handleGetCurrenciesList()
  }, [])

  useEffect(() => {
    if (summary) {
      handleSetForm(summary)
    }
    // eslint-disable-next-line
  }, [summary])

  const handleSetForm = (value) => {
    const dataDetail = {
      currency_origin: value.goodsCurrency,
      currency_order: value.orderCurrency,
      conversion: summary.customCurrencyRate,
      user_conversion: summary.goodsCurrencyRate,
    }
    setFormData(dataDetail)
  }

  const handleChangeForm = (name, val) => {
    setFormData((oldVal) => ({ ...oldVal, [name]: val}))
  }

  const mappingFormCurrency = (data) => {
    if (data.length > 0) {
      return (
        <Box>
          <Grid>
            <Grid.Col span={6}>
              <Select
                name='currency_origin'
                value={formData.currency_origin}
                label='Goods Currency'
                placeholder='Select Currency'
                data={currencyList}
                onChange={(val) => handleChangeForm('currency_origin', val)}
                size='xs'
                withAsterisk
                allowDeselect={false}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <Select
                name='currency_order'
                value={formData.currency_order}
                label='Order Currency'
                placeholder='Select Currency'
                data={currencyList}
                onChange={(val) => handleChangeForm('currency_order', val)}
                size='xs'
                withAsterisk
                allowDeselect={false}
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <NumberInput
                label="Goods Currency Rate"
                value={formData.user_conversion}
                prefix={`${formData.currency_order}  `}
                onChange={(val) => handleChangeForm('user_conversion', val)}
                error={validationForm.user_conversion.isError ? `${validationForm.user_conversion.message}` : ''}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator="."
                decimalSeparator=","
                defaultValue={0}
                size='xs'
              />
            </Grid.Col>
            <Grid.Col span={6}>
              <NumberInput
                label="Custom Currency Rate"
                value={formData.conversion}
                prefix={`${formData.currency_order}  `}
                onChange={(val) => handleChangeForm('conversion', val)}
                error={validationForm.conversion.isError ? `${validationForm.conversion.message}` : ''}
                decimalScale={2}
                fixedDecimalScale
                thousandSeparator="."
                decimalSeparator=","
                defaultValue={0}
                size='xs'
              />
            </Grid.Col>
          </Grid>
          <Box mt={20}>
            <Flex justify='flex-end'>
              <Group>
                <Button size='xs' variant="outline" onClick={onCloseForm}>Close</Button>
                <Button size='xs' loading={loadingForm} variant="filled" onClick={() => submitUpdateCurrency(formData)}>{summary ? 'Update' : 'Create'}</Button>
              </Group>
            </Flex>
          </Box>
        </Box>
      )
    }
  }

  return (
    <Box>
      {loadingCurrencies ? <LoadingData/> : mappingFormCurrency(currencyList)}
    </Box>
  )
}

export default FormAdjustCurrency